var angular = require('angular');
angular.module('promemoria', []);



// WEBPACK FOOTER //
// ./src/config.js